import(/* webpackMode: "eager" */ "/vercel/path0/app/extractor/pricing/page.tsx");
